import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import SubHero from '../components/SubHero';
import Socials from '../components/Socials';
import '../styles/Main.css';

export default function Main() {
  return (
    <>
      <Helmet>
        <title>Spardhaweb: MPSC Preparation Website | Free Test Series & Study Material</title>
        <meta 
          name="description" 
          content="Access free MPSC test series on Spardha Web. Enhance your preparation with daily quizzes, current affairs updates, and tailored resources to excel in your MPSC exams. Start your free test series now and boost your preparation!" 
        />
        <meta 
          name="keywords" 
          content="free MPSC test series, MPSC test series, free test series, MPSC exam preparation, daily quizzes, current affairs in Marathi, MPSC study material, MPSC ebooks" 
        />
        
        {/* Open Graph Tags for Social Media */}
        <meta property="og:title" content="Spardhaweb: MPSC Preparation Website" />
        <meta 
          property="og:description" 
          content="Access free MPSC test series on Spardha Web. Enhance your preparation with daily quizzes, current affairs updates, and tailored resources to excel in your MPSC exams." 
        />
        <meta property="og:image" content={`${window.location.origin}/logo_.jpg`} />
        <meta property="og:url" content="https://spardhaweb.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Spardhaweb" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Spardhaweb: MPSC Preparation Website" />
        <meta 
          name="twitter:description" 
          content="Access free MPSC test series, daily quizzes, and current affairs updates for MPSC exam preparation." 
        />
        <meta name="twitter:image" content={`${window.location.origin}/logo_.jpg`} />
        
        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Spardhaweb" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://spardhaweb.com/" />
      </Helmet>

      <div className="main-wrapper">
        <Navbar />
        <Socials />
        
        <main className="main-content">
          <Hero />
          <SubHero />
        </main>
        
        <Footer />
      </div>
    </>
  );
}